import { cn } from '@/shared/utils'
import { STATUS_BADGE_STYLES } from '@/shared/constants'

interface Props { status: string; className?: string }

export function StatusBadge({ status, className }: Props) {
  const style = STATUS_BADGE_STYLES[status.toLowerCase()] || 'bg-gray-100 text-gray-700 border border-gray-200'
  return (
    <span className={cn('inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold capitalize', style, className)}>
      {status}
    </span>
  )
}

interface BadgeProps { color?: 'blue'|'green'|'amber'|'red'|'purple'|'gray'; children: React.ReactNode; className?: string }
const badgeColors = { blue:'bg-brand-50 text-brand-700 border-brand-200', green:'bg-green-50 text-green-700 border-green-200', amber:'bg-brand-50 text-brand-700 border-brand-200', red:'bg-red-50 text-red-700 border-red-200', purple:'bg-purple-50 text-purple-700 border-purple-200', gray:'bg-gray-100 text-gray-700 border-gray-200' }

export function Badge({ color='gray', children, className }: BadgeProps) {
  return <span className={cn('inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border', badgeColors[color], className)}>{children}</span>
}
